<template>
  <div class="index row-me">

    <div class="left-div" :class="{ 'left-div-close': !isOpened }">
      <div class="posAbsoluteAll column-me row-center">
        <img src="../assets/img/logo2.png" class="img-text" v-if="isOpened"/>
        <img src="../assets/img/logo.png" class="img-logo" v-else/>
        <div class="menu-div flex1 column-me" v-dragscroll.y="true">
          <div class="width100Per">
            <div class="item-menu column-me center-all anim-bigger-small"
                 :class="{'item-menu-active':item.isCheck}" v-for="(item, index) in menuArray" :key="index"
                 :title="item.name" @click="clickMenu(item)" @mouseenter="menuMouseEnter(item)"
                 @mouseleave="menuMouseLeave(item)">
              <img :src="item.checkedIcon" class="img-menu" v-if="item.isCheck"/>
              <img :src="item.icon" class="img-menu" v-else/>
              <div class="menu-text" :class="{'menu-text-active': item.isCheck}" v-if="isOpened">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="right-div column-me flex1" style="overflow: auto">
      <div class="top-div row-me row-center">
        <img src="../assets/img/menu.png" class="margin-left20 pointer" title="合上" @click="clickClose"
             v-if="isOpened"/>
        <img src="../assets/img/menu1.png" class="margin-left20 pointer" title="展开" @click="clickClose"
             v-else/>
        <div class="flex1"></div>
        <el-image :src="user.headImage" :preview-src-list="[user.headImage]" fit="cover" class="img-header">
          <template #error>
            <img src="../assets/img/no_img_head.png" slot="error"
                 class="width100Per height100Per objFitCover"/>
          </template>
        </el-image>
        <el-popover placement="bottom" :width="100" trigger="hover">
          <div class="column-me center-all">
            <div class="user-info-text" @click="clickUserInfo">修改密码</div>
          </div>
          <template #reference>
            <div class="title1 margin-left10 margin-right20" v-if="user">
              {{ user.name ? user.name : '未知用户' }}
            </div>
          </template>
        </el-popover>
        <div class="line-shu"></div>
        <div class="row-me row-center margin-left20 pointer" @click="clickExit">
          <img src="../assets/img/exit.png" title="退出登录" class="img-icon"/>
          <div class="title1 margin-left5 margin-right50" v-if="user">退出</div>
        </div>
      </div>
      <div class="column-me flex1" style="overflow: auto;">
        <div class="second-menu-div row-me row-center" v-dragscroll.x="true" @mouseenter="openMenu"
             @mouseleave="closeMenu" v-show="menuArray1.length!==0">
          <div class="item-menu-two posRelative" :class="{ 'item-menu-two-active': item.isCheck }"
               v-for="(item, index) in menuArray1" :key="index" @click="clickMenuTwo(item)">
            <div>{{ item.name }}</div>
            <div class="red-point" v-if="item.name==='接方管理' && prescriptionNumber>0"></div>
          </div>
        </div>
        <div class="main-content flex1">
          <router-view></router-view>
        </div>
      </div>
    </div>

    <!-- 修改密码 -->
    <el-dialog title="修改密码" v-model="visiblePassword" width="35%" top="10vh" :destroy-on-close="true">
      <div class="padding20">
        <div class="row-me row-center">
          <div class="width90 text-justify">当前账号</div>
          <div>：</div>
          <div class="flex1 margin-left10">{{ user.loginName }}</div>
        </div>
        <div class="row-me row-center margin-top20">
          <div class="width90 text-justify">原密码</div>
          <div>：</div>
          <div class="flex1">
            <el-input placeholder="请输入6-12位密码" style="width: 100%;" :type="pwdType0" clearable
                      :minlength="6" :maxlength="12" v-model="password0"
                      :class="{'red-border':showRedBorder&&password0===''}">
            </el-input>
          </div>
          <img
              :src="pwdType0==='password'?require('../assets/img/eye_icon.png'):require('../assets/img/not_eye_icon.png')"
              class="img-icon margin-left15 pointer" @click="clickPwd0">
        </div>
        <div class="row-me row-center margin-top20">
          <div class="width90 text-justify">新密码</div>
          <div>：</div>
          <div class="flex1">
            <el-input placeholder="请输入6-12位密码" style="width: 100%;" :type="pwdType1" clearable
                      :minlength="6" :maxlength="12" v-model="password1"
                      :class="{'red-border':showRedBorder&&password1===''}">
            </el-input>
          </div>
          <img
              :src="pwdType1==='password'?require('../assets/img/eye_icon.png'):require('../assets/img/not_eye_icon.png')"
              class="img-icon margin-left15 pointer" @click="clickPwd1">
        </div>
        <div class="row-me row-center margin-top20">
          <div class="width90 text-justify">确认新密码</div>
          <div>：</div>
          <div class="flex1">
            <el-input placeholder="请输入6-12位密码" style="width: 100%;" :type="pwdType2" clearable
                      :minlength="6" :maxlength="12" v-model="password2"
                      :class="{'red-border':showRedBorder&&password2===''}">
            </el-input>
          </div>
          <img
              :src="pwdType2==='password'?require('../assets/img/eye_icon.png'):require('../assets/img/not_eye_icon.png')"
              class="img-icon margin-left15 pointer" @click="clickPwd2">
        </div>
        <div class="row-me row-center flex-end1 margin-top100">
          <div class="btn-blue width140 btn-height40" @click="clickSave">提交</div>
          <div class="btn-grey width140 btn-height40 margin-left20" @click="clickCancel">取消</div>
        </div>
      </div>
    </el-dialog>

    <!--新订单语音播报-->
    <audio ref="audio" controls="controls" hidden :src="mp3Url"></audio>

    <!--加载动画-->
    <loading v-if="showLoading"></loading>
  </div>
</template>

<script>
import axios from 'axios'
import loading from "../components/loading.vue";

let interval;

export default {
  components: {loading},
  data() {
    return {
      isOpened: true, //菜单展开
      menuArray: [], //左侧菜单
      menuArray1: [], //二级菜单
      showSecondMenu: false,
      user: {}, //当前登录用户
      visiblePassword: false,
      password0: '',
      password1: '',
      password2: '',
      pwdType0: 'password',
      pwdType1: 'password',
      pwdType2: 'password',
      showRedBorder: false,
      mp3Url: require('../assets/audios/rings.mp3'),
      socket: "",
      heartCheck: null,
      isUsedRing: true,//是否开启语音
      prescriptionNumber: 0,//待接方订单数量
      showLoading: false,//显示加载动画
    };
  },
  // html加载完成之前
  created() {
    let that = this
    setTimeout(() => {
      let token = sessionStorage.getItem('token')
      if (!token || token === '') {
        that.$router.replace({
          path: '/login'
        })
        return
      }
      let user = JSON.parse(sessionStorage.getItem('user'))
      if (!user || user === '') {
        that.$router.replace({
          path: '/login'
        })
        return
      }
    }, 1000)
    let menuOpen = localStorage.getItem("menuOpen");
    this.isOpened = menuOpen === null || menuOpen === true || menuOpen === "true";
    //=========获取菜单============
    this.$getRequest('/admin/newLogin/buildUserMenu', {}).then((res) => {
      if (res) {
        for (var i = 0; i < res.data.length; i++) {
          let item1 = res.data[i]
          if (item1.icon && item1.icon !== '') {
            item1.icon = require('/src/assets/img' + item1.icon)
          }
          if (item1.checkedIcon && item1.checkedIcon !== '') {
            item1.checkedIcon = require('/src/assets/img' + item1.checkedIcon)
          }
        }
        this.menuArray = res.data;
        this.dealMenu()
      }
    }).catch((error) => {
      console.log(error)
    })
  },
  // html加载完成后执行。
  mounted() {
    let user = JSON.parse(sessionStorage.getItem('user'))
    if (user && user !== '') {
      this.user = user
    }
    this.getUserInfo()
    this.getRingStatus()
    //加载中动画监听
    this.bus.$on('loading', res => {
      this.showLoading = res === 1
    })
  },
  // 事件方法执行
  methods: {
    //获取是否开启语音
    getRingStatus() {
      this.$getRequest('/admin/systemConfig/getIsVoice', {}).then((res) => {
        if (res) {
          this.isUsedRing = res.data
          //初始化websocket
          this.initWebSocket()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //新订单监听
    initWebSocket() {
      let that = this
      if (typeof (WebSocket) === "undefined") {
        alert("您的浏览器不支持socket")
      } else {
        this.heartCheck = {
          timeout: 10000,
          intervalObj: null,
          reset: function () {
            clearInterval(this.intervalObj);
            this.start();
          },
          start: function () {
            let self = this
            that.socket.send("test");
            this.intervalObj = setInterval(function () {
              that.socket.send("test");
            }, this.timeout)
          },
        }
        // 实例化socket
        let user = JSON.parse(sessionStorage.getItem('user'))
        let url = axios.defaults.webSocket + '/admin/webSocket/' + user.companyId + '/' + new Date().getTime()
        this.socket = new WebSocket(url)
        // 监听socket连接
        this.socket.onopen = this.open
        // 监听socket错误信息
        this.socket.onerror = this.error
        // 监听socket消息
        this.socket.onmessage = this.getMessage
        //监听socket关闭
        this.socket.onclose = this.onClose
      }
    },
    open: function () {
      console.log("socket连接成功")
      if (interval) {
        clearInterval(interval)
      }
      this.heartCheck.start();
    },
    error: function () {
      console.log("连接错误")
      this.reconnect();
    },
    onClose: function () {
      console.log("连接关闭")
      this.reconnect();
    },
    getMessage: function (msg) {
      console.log("----websocket接收内容-------")
      console.log(msg.data)
      this.heartCheck.reset();
      if (msg.data) {
        let obj = JSON.parse(msg.data)
        if (this.isUsedRing) {
          this.$refs.audio.currentTime = 0; //从头开始播放
          this.$refs.audio.play(); //播放
        }
        this.prescriptionNumber = Number(obj.count)
      }
    },
    // 重连
    reconnect() {
      let that = this
      // 进行重连
      if (interval) {
        clearInterval(interval)
      }
      interval = setInterval(function () {
        that.initWebSocket()
      }, 3000);
    },
    //处理菜单点击事件
    dealMenu() {
      if (this.menuArray.length > 0) {
        //初始化之前选中的菜单
        let clickMenuUrl1 = sessionStorage.getItem('clickMenuUrl1')
        let clickMenuUrl2 = sessionStorage.getItem('clickMenuUrl2')
        if (clickMenuUrl1 !== null) {
          let isHad1 = false
          for (let i = 0; i < this.menuArray.length; i++) {
            let item1 = this.menuArray[i]
            if (item1.url === clickMenuUrl1) {
              isHad1 = true
              item1.isCheck = true
              this.menuArray1 = item1.children;
              if (this.menuArray1.length > 0) {
                //初始化二级选中菜单
                if (clickMenuUrl2 !== null) {
                  let isHad2 = false;
                  for (let j = 0; j < this.menuArray1.length; j++) {
                    let item2 = this.menuArray1[j]
                    if (item2.url === clickMenuUrl2) {
                      item2.isCheck = true
                      isHad2 = true
                    }
                  }
                  if (!isHad2) {//当前二级菜单没有权限了
                    this.menuArray1[0].isCheck = true;
                    this.$router.push(this.menuArray1[0].url)
                    sessionStorage.setItem("clickMenuUrl2", this.menuArray1[0].url);
                  }
                } else {
                  this.menuArray1[0].isCheck = true;
                }
              }
            }
          }
          if (!isHad1) {//当前一级菜单没有权限了
            this.menuArray[0].isCheck = true;
            this.menuArray1 = this.menuArray[0].children;
            if (this.menuArray1.length > 0) {
              this.menuArray1[0].isCheck = true;
              this.$router.push(this.menuArray1[0].url)
              sessionStorage.setItem("clickMenuUrl2", this.menuArray1[0].url);
            } else {
              this.$router.push(this.menuArray[0].url)
              sessionStorage.setItem("clickMenuUrl1", this.menuArray[0].url);
            }
          }
        } else {
          //以下是登录后默认打开第一个菜单
          if (this.menuArray.length > 0) {
            this.menuArray[0].isCheck = true;
            this.menuArray1 = this.menuArray[0].children;
            if (this.menuArray1.length > 0) {
              this.menuArray1[0].isCheck = true;
              this.$router.push(this.menuArray1[0].url)
              sessionStorage.setItem("clickMenuUrl2", this.menuArray1[0].url);
            } else {
              this.$router.push(this.menuArray[0].url)
              sessionStorage.setItem("clickMenuUrl1", this.menuArray[0].url);
            }
          }
        }
      }
    },
    //个人信息
    clickUserInfo() {
      this.showRedBorder = false
      this.password0 = ''
      this.password1 = ''
      this.password2 = ''
      this.visiblePassword = true
    },
    clickPwd0() {
      this.pwdType0 = this.pwdType0 === 'password' ? 'text' : 'password'
    },
    clickPwd1() {
      this.pwdType1 = this.pwdType1 === 'password' ? 'text' : 'password'
    },
    clickPwd2() {
      this.pwdType2 = this.pwdType2 === 'password' ? 'text' : 'password'
    },
    //取消
    clickCancel() {
      this.visiblePassword = false
    },
    //提交
    clickSave() {
      let that = this
      if (this.password0 === '' || this.password1 === '' || this.password2 === '') {
        this.showRedBorder = true
        return
      }
      if (this.password1.length < 6) {
        this.$message.error('密码不能低于6位')
        return
      }
      if (this.password1 !== this.password2) {
        this.$message.error('两次新密码不一致')
        return
      }
      this.$postFormRequest('/admin/adminUser/updateMyPassword', {
        oldPassword: this.password0,
        password: this.password1,
      }).then((res) => {
        if (res) {
          this.visiblePassword = false
          this.$message.success('修改成功，请重新登录')
          setTimeout(() => {
            that.$router.replace({
              path: '/login'
            })
          }, 1000)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //退出登录
    clickExit() {
      this.$confirm('您确定要退出登录吗？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let source = sessionStorage.getItem('source')
        sessionStorage.removeItem('user')
        sessionStorage.removeItem('token')
        if (source === 'storePlatform') {//店务平台打开的
          window.location.replace('https://admin.gyyltec.com/View/Login/Index.html')
        } else {
          this.$router.replace({
            path: '/login',
            params: {}
          })
        }
      }).catch(() => {

      });
    },
    //菜单展开合并
    clickClose() {
      this.isOpened = !this.isOpened;
      localStorage.setItem("menuOpen", this.isOpened);
    },
    //一级菜单移入
    menuMouseEnter(item) {
      // this.menuArray1 = item.children;
      // this.showSecondMenu = this.menuArray1.length > 0;//新需求一直显示二级菜单
    },
    //
    menuMouseLeave(item) {
      // this.showSecondMenu = false//新需求一直显示二级菜单
    },
    //菜单点击
    clickMenu(item) {
      for (let i = 0; i < this.menuArray.length; i++) {
        let menu = this.menuArray[i];
        menu.isCheck = false;
      }
      item.isCheck = true;
      this.menuArray1 = item.children;
      let clickMenuUrl1 = sessionStorage.getItem('clickMenuUrl1')
      if (clickMenuUrl1 !== item.url) {
        for (let i = 0; i < this.menuArray1.length; i++) {
          let menu = this.menuArray1[i];
          if (i === 0) {
            menu.isCheck = true;
            this.$router.push({
              path: menu.url,
              query: {},
            });
          } else {
            menu.isCheck = false;
          }
        }
        if (this.menuArray1.length === 0) {
          this.$router.push({
            path: item.url,
            query: {},
          });
        }
      }
      sessionStorage.setItem("clickMenuUrl1", item.url);
      // this.showSecondMenu = this.menuArray1.length > 0;//新需求一直显示二级菜单
    },
    //二级菜单点击
    clickMenuTwo(item) {
      for (let i = 0; i < this.menuArray1.length; i++) {
        let menu = this.menuArray1[i];
        menu.isCheck = false;
      }
      item.isCheck = true;
      sessionStorage.setItem("clickMenuUrl2", item.url);
      this.$router.push({
        path: item.url,
        query: {},
      });
      // this.showSecondMenu = false;//新需求一直显示二级菜单
    },
    openMenu() {
      // this.showSecondMenu = true;//新需求一直显示二级菜单
    },
    closeMenu() {
      // this.showSecondMenu = false;//新需求一直显示二级菜单
    },
    //获取用户信息
    getUserInfo() {
      this.$getRequest('/admin/login/info', {}).then((res) => {
        if (res) {
          sessionStorage.setItem('user', JSON.stringify(res.data))
          this.user = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {
    $route: {
      handler(val, oldVal) {
        let path = val.path
        let oldPath = oldVal.path
        let needChange = false
        let item11 = null
        let item22 = null
        for (let i = 0; i < this.menuArray.length; i++) {
          let item1 = this.menuArray[i]
          for (let j = 0; j < item1.children.length; j++) {
            let item2 = item1.children[j]
            if (item2.url === path && path !== oldPath) {
              needChange = true
              item11 = item1
              item22 = item2
            }
          }
          if (item1.children.length === 0) {
            needChange = true
            item11 = item1
          }
        }
        if (needChange) {
          for (let i = 0; i < this.menuArray.length; i++) {
            let item1 = this.menuArray[i]
            item1.isCheck = false
            for (let j = 0; j < item1.children.length; j++) {
              let item2 = item1.children[j]
              item2.isCheck = false
            }
          }
          this.menuArray1 = item11.children
          if (item11) {
            item11.isCheck = true
            sessionStorage.setItem("clickMenuUrl1", item11.url);
          }
          if (item22) {
            item22.isCheck = true
            sessionStorage.setItem("clickMenuUrl2", item22.url);
          }
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  unmounted() {
    // 销毁监听
    this.bus.$off('loading')
    this.socket.onclose = this.close
  }
};
</script>

<style lang="scss" scoped>
.index {
  width: 100vw;
  height: 100vh;
  font-size: 18px;
  color: #222222;

  .left-div {
    width: 150px;
    height: 100%;
    background: #215AA0;
    position: relative;
    transition: 0.3s;

    &-close {
      width: 80px;
    }

    .img-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }

    .img-text {
      width: 80%;
      object-fit: scale-down;
      margin-top: 10px;
      user-select: none;
      pointer-events: none;
    }

    .img-logo {
      width: 60px;
      height: 60px;
      margin-top: 30px;
      user-select: none;
      pointer-events: none;
    }

    .img-hong {
      width: 140px;
      height: 165px;
      object-fit: scale-down;
      user-select: none;
      pointer-events: none;
    }

    .menu-div {
      width: 100%;
      margin-top: 10px;
      overflow: auto;
      align-items: flex-end;
      /* Firefox */
      scrollbar-width: none;
      /* IE 10+ */
      -ms-overflow-style: none;

      /* Chrome Safari */
      &::-webkit-scrollbar {
        display: none;
      }

      .item-menu {
        width: 100%;
        height: 120px;
        cursor: pointer;

        &-active {
          background: #154C93;
        }

        &:hover {
          background: #154C93;
        }

        .img-menu {
          width: 30px;
          height: 30px;
          object-fit: scale-down;
        }

        .menu-text {
          font-size: 18px;
          color: rgba(255, 255, 255, 0.5);
          word-break: keep-all;
          text-overflow: ellipsis;
          margin-top: 10px;

          &-active {
            color: #FFFFFF;
          }
        }
      }
    }
  }

  .right-div {
    height: 100%;

    .top-div {
      width: 100%;
      height: 80px;
      background-image: url(../assets/img/backgroundhead1.png);
      background-size: 100%;

      .img-header {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }

      .title1 {
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-size: 18px;
        color: #FFFFFF;
        cursor: pointer;
      }

      .line-shu {
        width: 1px;
        height: 24px;
        background: #ECECEC;
      }

      .title {
        font-size: 20px;
        color: #222222;
      }

      .img-icon {
        width: 30px;
        height: 30px;
        object-fit: scale-down;
      }
    }

    .second-menu-div {
      width: 100%;
      height: 60px;
      background: #ffffff;
      box-shadow: 0 0 5px #F3F3F3;
      z-index: 10;
      overflow: auto;
      // animation: openMenu 0.2s 1 ease-out;
      transition: 0.3s;
      /* Firefox */
      scrollbar-width: none;
      /* IE 10+ */
      -ms-overflow-style: none;

      /* Chrome Safari */
      &::-webkit-scrollbar {
        display: none;
      }

      .item-menu-two {
        height: 60px;
        line-height: 60px;
        text-align: center;
        padding: 0 30px;
        font-size: 18px;
        color: #666666;
        cursor: pointer;
        word-break: keep-all;
        text-overflow: ellipsis;

        &-active {
          background: #E8EEF9;
          font-weight: bold;
          color: #215AA0;
        }

        &:hover {
          background: #E8EEF9;
        }

        .red-point {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #ff0000;
          position: absolute;
          top: 10px;
          right: 10px;
        }
      }
    }

    @keyframes openMenu {
      0% {
        width: 0;
      }

      100% {
        width: 160px;
      }
    }

    .main-content {
      font-size: 18px;
      color: #252630;
      background: #F5F6F8;
      height: 100%;
      overflow: auto;
    }
  }
}

.user-info-text {
  color: #000000;
  font-size: 18px;
  cursor: pointer;

  &:hover {
    font-weight: bold;
  }
}
</style>
